import { motion } from "framer-motion";
import { PROCESS, IMAGES } from "@/data/site";

export const Manifesto = () => {
  return (
    <section id="methode" className="bg-mh-bg2 border-y border-mh-line">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32 grid lg:grid-cols-[1fr_1.1fr] gap-16">
        <div className="lg:sticky lg:top-28 h-fit">
          <span className="text-xs tracking-[0.25em] uppercase text-mh-orange font-bold">Notre méthode</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl tracking-tight text-white leading-[0.95]">
            Rigueur, transparence et garantie
          </h2>
          <p className="mt-6 text-mh-slate leading-relaxed max-w-md">
            Chaque chantier suit un protocole précis, du diagnostic à la garantie décennale.
            Vous savez exactement ce que vous payez et ce que vous obtenez.
          </p>
          <div className="mt-10 relative h-64 clip-corner-tl overflow-hidden border border-mh-line">
            <img src={IMAGES.roofer} alt="Étancheur au travail" className="w-full h-full object-cover img-arch" />
          </div>
        </div>

        <div className="flex flex-col">
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="relative border-t border-mh-line py-10 last:border-b"
              data-testid={`process-${p.n}`}
            >
              <span className="font-display font-black text-mh-line text-6xl sm:text-7xl absolute -top-2 right-0 select-none">
                {p.n}
              </span>
              <h3 className="font-display font-bold text-2xl text-white tracking-tight relative">{p.title}</h3>
              <p className="mt-3 text-mh-slate leading-relaxed max-w-lg relative">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
